/* eslint-disable import/prefer-default-export */
/**
 * Copyright (C) 2019 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

/**
 * This class represents the utility functions for the flight phase of an aircraft.
 */
export enum FlightPhase {
  inFlight = 'In Flight',
  ascending = 'Ascending',
  descending = 'Descending',
  onDeck = 'On Deck',
}
